(function () {
    'use strict';

    angular
        .module('partners')
        .controller('PartnerFormController', PartnerFormController);

    PartnerFormController.$inject = ['$state', '$stateParams', 'ManagePartnersService', 'ExpoService', 'PartnerCampaignMediumService', 'CurrencyService', 'expos', 'virtualFairs', 'eventTypes'];

    function PartnerFormController($state, $stateParams, ManagePartnersService, ExpoService, PartnerCampaignMediumService, CurrencyService, expos, virtualFairs, eventTypes) {
        var vm = this;

        vm.id                  = '';
        vm.event_id            = '';
        vm.name                = '';
        vm.campaign_source     = '';
        vm.campaign_medium_id  = '';
        vm.campaign_content    = '';
        vm.short_url_key       = '';
        vm.investment_currency = '';
        vm.investment          = '';
        vm.eventTypes          = eventTypes;
        vm.event_type          = 'expo';

        vm.selectedEvent    = '';
        vm.selectedMedium   = '';
        vm.selectedCurrency = '';

        vm.expos      = [];
        vm.medium     = [];
        vm.currencies = [];

        vm.getPartnersCampaignMedium = getPartnersCampaignMedium;
        vm.getCurrencies             = getCurrencies;
        vm.getAdmPartnerUsers        = getAdmPartnerUsers;

        vm.submit = submit;
        vm.edit   = edit;

        vm.formErrors = [];


        function activate() {
            console.log(eventTypes);
            vm.expos = expos;
            vm.virtualFairs = virtualFairs;
            vm.getPartnersCampaignMedium();
            vm.getCurrencies();
            vm.getAdmPartnerUsers();

            if ($stateParams.hasOwnProperty('id')) {
                vm.edit($stateParams.id);
            }
        }

        function getPartnersCampaignMedium() {
            PartnerCampaignMediumService.getPartnersCampaignMedium().then(function(response){
                vm.medium = response.data;
            });
        }

        function getCurrencies() {
            CurrencyService.getCurrencies().then(function(response){
                vm.currencies = response.data;
            });
        }

        function getAdmPartnerUsers() {
            ManagePartnersService.getAdmPartnerUsers().then(function(response){
                vm.admPartnerUsers = response.data;
            });
        }

        function submit() {
            vm.fields = {
                event_id            : vm.selectedEvent.id,
                event_type          : vm.event_type,
                name                : vm.name,
                campaign_source     : vm.campaign_source,
                campaign_medium_id  : vm.selectedMedium.id,
                campaign_content    : vm.campaign_content,
                short_url_key       : vm.short_url_key,
                investment_currency : vm.selectedCurrency.code,
                investment          : vm.investment,
                adm_partner_user_id : vm.adm_partner_user_id
            };

            if ($stateParams.hasOwnProperty('id')) {
                ManagePartnersService.update($stateParams.id, vm.fields)
                    .then(function(response) {
                        if (response.errors) {
                            vm.formErrors = response.errors;
                        } else {
                            $state.go('root.partners.list')
                        }
                    })
                    .catch(function(err) {
                        console.error(err);
                    });

            } else {
                ManagePartnersService.store(vm.fields)
                    .then(function(response) {
                        if (response.errors) {
                            vm.formErrors = response.errors;
                        } else {
                            $state.go('root.partners.list')
                        }
                    })
                    .catch(function(err) {
                        console.error(err);
                    });
            }
        }

        function edit(id) {
            ManagePartnersService.get(id).then(function(response) {
                vm.id                  = response.data.id;
                vm.event_type          = response.data.event_type;
                vm.event_id            = response.data.event_id;
                vm.name                = response.data.name;
                vm.campaign_source     = response.data.campaign_source;
                vm.campaign_medium_id  = response.data.campaign_medium.id;
                vm.campaign_content    = response.data.campaign_content;
                vm.short_url_key       = response.data.short_url_key;
                vm.investment_currency = response.data.currency.code;
                vm.investment          = response.data.investment;
                vm.adm_partner_user_id = response.data.adm_partner_user_id;
                if(response.data.event_type == 'virtual_fair') {
                    let partnerExpo = vm.virtualFairs.filter(function(item) {
                        return item.id == response.data.event_id
                    });
                    if(partnerExpo.length > 0) {
                        vm.selectedEvent  = partnerExpo[0];
                    }
                }
                if(response.data.event_type == 'expo') {
                    let partnerExpo = vm.expos.filter(function(item) {
                        return item.id == response.data.event_id
                    });
                    if(partnerExpo.length > 0) {
                        vm.selectedEvent  = partnerExpo[0];
                    }
                }
                vm.selectedMedium   = response.data.campaign_medium;
                vm.selectedCurrency = response.data.currency;
            });
        }

        activate();
    }

})();